import { BookOpenIcon, CalculatorIcon, ClipboardCheckIcon, LayersIcon, MapIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Underground Mining Formulas & Calculations Quick-Reference',
    description: 'Key underground mining formulas and worked calculations gathered in one quick reference.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Underground Shift Inspection & Pre-Start Checklists',
    description: 'Shift inspection and pre-start checklists organized for daily use underground.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: 'Ground Conditions Field Guide: Reading the Rock & Spotting Warning Signs',
    description: 'How to read the rock and recognize common warning signs in ground conditions.',
    icon: LayersIcon,
  },
  {
    number: '4',
    title: 'How to Read Underground Mine Plans, Long Sections & Development Drawings',
    description: 'How to interpret underground mine plans, long sections and development drawings.',
    icon: MapIcon,
  },
  {
    number: '5',
    title: 'Underground Mining Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in underground mining and mine operations.',
    icon: BookOpenIcon,
  },
];
